// fetchUserSubscription.js
'use strict';
import 'isomorphic-fetch';
import debounce from 'lodash/debounce';

import getMeData from '../selector/getMeData.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import handleFetchError from '../resource/handleFetchError.js';

import {
  ADD_USERS,
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

const debounceFunctionMap = {};
// Use debounce to reduce a lot of same request in post feed
const debouncedFetchUserSubscription =
  (payload = {}) =>
  async dispatch => {
    const key = Object.values(payload).join(':');
    if (!debounceFunctionMap[key]) {
      debounceFunctionMap[key] = debounce(
        payload => dispatch(fetchUserSubscription(payload)),
        1000
      );
    }
    return debounceFunctionMap[key](payload);
  };

/**
 * Fetch user subscription
 * @kind action
 * @param {string} {userId} - user id.
 * @return {Promise} Action promise.
 */
export const fetchUserSubscription =
  ({ userId } = {}) =>
  async (dispatch, getState) => {
    const token = getMeData(getState(), 'token');
    if (!token || !userId) {
      return dispatch({ type: '' });
    }
    const networkingSelectPath = ['fetch', 'user', userId, 'subscription'];
    const fetchOptions = {
      method: 'GET',
      headers: {
        ...getHeaders(),
        Authorization: `Bearer ${token}`,
      },
    };
    const fetchUrl = getResourceUrl({
      endpoint: `/users/${userId}/subscription`,
    });
    dispatch({
      type: SET_NETWORKING_FETCHING,
      payload: { selectPath: networkingSelectPath },
    });
    try {
      let response = await fetch(fetchUrl.href, fetchOptions);
      if (!response.ok) {
        response = await handleFetchError({
          response,
          dispatch,
          getState,
          fetchOptions,
          fetchUrl,
        });
      }
      const { nbf, exp, plan, next_renew } = (await response.json()) || {};
      dispatch({
        type: ADD_USERS,
        payload: {
          users: {
            [userId]: {
              id: userId,
              meSubscription: {
                nbf,
                exp,
                nextRenew: next_renew,
                plan,
              },
            },
          },
        },
      });
      return dispatch({
        type: SET_NETWORKING_SUCCESS,
        payload: { selectPath: networkingSelectPath },
      });
    } catch (error) {
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath: networkingSelectPath, error },
      });
    }
  };

export default debouncedFetchUserSubscription;
